import React from "react";
import "./MsFileViewer.css";

import { MsRequest } from "./MsRequest";
import { MsViewport } from "./MsViewport";

interface IMsFileViewerProps {
  asset: IMSAsset;
}

const MsFileViewer = ({ asset }: IMsFileViewerProps) => {
  if (!asset) {
    return null;
  }

  return asset.wopiPayload
    ? renderMsFile(asset.wopiPayload)
    : renderPreview(asset);
};

export function renderMsFile(wopi: IWopiAccess): JSX.Element {
  return (
    <div className="mv-asset-viewer mv-asset-viewer__container">
      <MsRequest wopi={wopi} />
      <MsViewport />
    </div>
  );
}

export function renderPreview(asset: IAsset) {
  return (
    <div className="mv-asset-viewer mv-asset-viewer__container">
      <img
        className="mv-detail__content--wopi-preview"
        src={asset.media.medium}
        alt={asset.altText ? asset.altText : ""}
      />
    </div>
  );
}

export default MsFileViewer;
